// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2c796e83" + "." + "ddc5b97fdc5312f6" + ".js";
};